import { sansSerifStyles } from "@pathwright/blocks/src/ui/typography"
import View from "@pathwright/ui/src/components/ui/View"
import styled from "styled-components"

export const BackgroundWrapper = styled.div`
  /* Quill color picker doesn't work if overflow is hidden */
  /* overflow: hidden; */
  position: relative;
  width: 100%;
  padding: 50px 0;
`

export const TitleWrapper = styled(View)`
  width: 100%;

  .BlockText,
  .ql-editor {
    text-align: center;

    & > p {
      font-weight: 300;
    }

    & > p strong {
      font-weight: 400 !important;
    }
  }

  // Fix Quill editor where link editor is centered and thus cut off
  .ql-tooltip-editor > input[type="text"] {
    left: 0 !important;
  }
`

export const TitleDivider = styled.hr`
  border: none;
  border-top: 1px solid rgb(204, 204, 204);
`

export const Title = styled.h1`
  width: 100%;
  margin: 0;
  text-align: center;
  ${sansSerifStyles({ size: 72 })}
  font-weight: 300;
  font-size: 72px;

  @media (max-width: 500px) {
    font-size: 48px;
  }

  /* Center title placeholder text properly */
  .ql-editor.ql-blank::before {
    width: 100%;
    left: 0;
  }

  /* styles to apply quill editor content */
  & > p,
  .ql-editor,
  .ql-editor p,
  .BlockText,
  .BlockText p,
  .ContentText,
  .ContentText.ql-editor,
  .ContentText.ql-editor .BlockText,
  .ContentText.ql-editor .BlockText p {
    // Ignore block styles colors
    color: ${(p) => `${p.headingColor}!important` || ""};
    margin: 0;
    font-size: inherit;
    font-weight: inherit;
    font-family: inherit;
    line-height: 1.3em;
    white-space: pre-wrap;
    word-wrap: inherit;
  }

  .ContentText.ql-editor .BlockText p {
    // Hide scrollbars:
    //  vertical scrollbar appears on PC browsers b/c of line height
    //  horizontal scrollbar appears on all (?) browsers
    overflow: hidden;
  }
`
